import { createSelector } from 'reselect';
import getOptinState from './getOptinState';
import { RootState } from '../../../stores/types';
import { OptinState } from '../types';

export default createSelector<RootState, OptinState, 'pending' | 'rejected' | 'loading' | 'fulfilled'>(
  getOptinState,
  (optinState: OptinState) => optinState.activeOptinAttribute.status,
);
